import React from "react";
import SkillMangComp from "../../components/SkillMangement/SkillMangComp";

const SkillManagement = () => {
  return (
    <>
      <SkillMangComp />
    </>
  );
};

export default SkillManagement;
